type FeatureFlags = {
  COMPLIANCE_CENTER_V2: boolean;
  UNIFIED_RECOMMENDATIONS_V2: boolean;
  EXTENDED_FIRST_METRICS: boolean;
  UNIFIED_ASSESSMENTS_V2: boolean;
  RECOMMENDATION_LIFECYCLE_V2: boolean;
  REMEDIATION_WORKFLOW_V2: boolean;
  VERIFIED_REMEDIATION_SCORING: boolean;
  CONTINUOUS_COMPLIANCE_AUTOMATION: boolean;
  AUTOMATED_EVIDENCE_COLLECTION: boolean;
  DRIFT_DETECTION_V1: boolean;
  CONNECTOR_FRAMEWORK_V1: boolean;
  CERTIFICATION_WORKFLOW_V1: boolean;
  AUDITOR_PORTAL_V1: boolean;
  AUDITOR_PACKAGE_REVIEW_V1: boolean;
  EXTERNAL_EVIDENCE_REVIEW_V1: boolean;
  AI_AUDIT_ASSISTANT_V1: boolean;
  AI_POLICY_GENERATION_V1: boolean;
  AI_REMEDIATION_ASSISTANT_V1: boolean;
  AI_EVIDENCE_REVIEW_V1: boolean;
  AI_AUDITOR_QA_V1: boolean;
  AI_GOVERNANCE_INTELLIGENCE_SURFACE_V1: boolean;
  AI_GOVERNANCE_INTELLIGENCE_REVIEW_V1: boolean;
  AI_GOVERNANCE_REMEDIATION_DRAFT_BRIDGE_V1: boolean;
  AI_GOVERNANCE_INTELLIGENCE_INTERACTION_V1: boolean;
  AI_PROVIDER_CONFIG_V2: boolean;
  AI_DATA_POLICY_V1: boolean;
  AI_DOCUMENT_INTELLIGENCE_V1: boolean;
  AI_DOCUMENT_RAG_V1: boolean;
  AI_DOCUMENT_RAG_QUALITY_V1: boolean;
  AI_LOCAL_MODELS_V1: boolean;
  STANDARD_ACCESS_POLICY_V1: boolean;
  STANDARD_SCOPE_VISIBILITY_V1: boolean;
  STANDARD_WRITE_GUARDRAILS_V1: boolean;
  COMPLIANCE_TOPOLOGY_V1: boolean;
  COMPLIANCE_TOPOLOGY_READINESS_V1: boolean;
  COMPLIANCE_WORKFLOW_V1: boolean;
  COMPLIANCE_REUSE_V1: boolean;
  CONTROL_ASSURANCE_V1: boolean;
  COMPLIANCE_RUNTIME_V1: boolean;
  EXECUTIVE_GOVERNANCE_V1: boolean;
  EXECUTIVE_POSTURE_WIDGETS_V1: boolean;
  ENTERPRISE_OPERATIONAL_UX_V1: boolean;
  CANONICAL_CONTROL_LIBRARY_V1: boolean;
  COMPLIANCE_EXECUTION_ORCHESTRATION_V1: boolean;
  COMPLIANCE_READINESS_SYNC_V1: boolean;
  COMPLIANCE_SCOPE_AUTHORITY_V1: boolean;
  COMPLIANCE_EVIDENCE_BINDING_V1: boolean;
  CONTROL_CENTRIC_WORKFLOW_UX_V2: boolean;
  STANDARD_CONTROL_CENTRIC_UX_V1: boolean;
  SOC2_AUTHORITATIVE_CORPUS_V1: boolean;
  ENTERPRISE_OPERATIONAL_SEMANTIC_CORPUS_V1: boolean;
  ENTERPRISE_AUTHORITATIVE_CORPUS_FREEZE_V1: boolean;
  CONTINUOUS_COMPLIANCE_OPERATIONS_V1: boolean;
  UNIFIED_REMEDIATION_AUTHORITY_V1: boolean;
};

const readBool = (name: string, fallback: boolean): boolean => {
  const raw = import.meta.env[name];
  if (raw == null) return fallback;
  return String(raw).toLowerCase() === "true";
};

export const featureFlags: FeatureFlags = {
  COMPLIANCE_CENTER_V2: readBool("VITE_COMPLIANCE_CENTER_V2", true),
  UNIFIED_RECOMMENDATIONS_V2: readBool("VITE_UNIFIED_RECOMMENDATIONS_V2", true),
  EXTENDED_FIRST_METRICS: readBool("VITE_EXTENDED_FIRST_METRICS", true),
  UNIFIED_ASSESSMENTS_V2: readBool("VITE_UNIFIED_ASSESSMENTS_V2", true),
  RECOMMENDATION_LIFECYCLE_V2: readBool("VITE_RECOMMENDATION_LIFECYCLE_V2", true),
  REMEDIATION_WORKFLOW_V2: readBool("VITE_REMEDIATION_WORKFLOW_V2", true),
  VERIFIED_REMEDIATION_SCORING: readBool("VITE_VERIFIED_REMEDIATION_SCORING", true),
  CONTINUOUS_COMPLIANCE_AUTOMATION: readBool("VITE_CONTINUOUS_COMPLIANCE_AUTOMATION", false),
  AUTOMATED_EVIDENCE_COLLECTION: readBool("VITE_AUTOMATED_EVIDENCE_COLLECTION", false),
  DRIFT_DETECTION_V1: readBool("VITE_DRIFT_DETECTION_V1", false),
  CONNECTOR_FRAMEWORK_V1: readBool("VITE_CONNECTOR_FRAMEWORK_V1", false),
  CERTIFICATION_WORKFLOW_V1: readBool("VITE_CERTIFICATION_WORKFLOW_V1", false),
  AUDITOR_PORTAL_V1: readBool("VITE_AUDITOR_PORTAL_V1", false),
  AUDITOR_PACKAGE_REVIEW_V1: readBool("VITE_AUDITOR_PACKAGE_REVIEW_V1", false),
  EXTERNAL_EVIDENCE_REVIEW_V1: readBool("VITE_EXTERNAL_EVIDENCE_REVIEW_V1", false),
  AI_AUDIT_ASSISTANT_V1: readBool("VITE_AI_AUDIT_ASSISTANT_V1", false),
  AI_POLICY_GENERATION_V1: readBool("VITE_AI_POLICY_GENERATION_V1", false),
  AI_REMEDIATION_ASSISTANT_V1: readBool("VITE_AI_REMEDIATION_ASSISTANT_V1", false),
  AI_EVIDENCE_REVIEW_V1: readBool("VITE_AI_EVIDENCE_REVIEW_V1", false),
  AI_AUDITOR_QA_V1: readBool("VITE_AI_AUDITOR_QA_V1", false),
  AI_GOVERNANCE_INTELLIGENCE_SURFACE_V1: readBool("VITE_AI_GOVERNANCE_INTELLIGENCE_SURFACE_V1", false),
  AI_GOVERNANCE_INTELLIGENCE_REVIEW_V1: readBool("VITE_AI_GOVERNANCE_INTELLIGENCE_REVIEW_V1", false),
  AI_GOVERNANCE_REMEDIATION_DRAFT_BRIDGE_V1: readBool("VITE_AI_GOVERNANCE_REMEDIATION_DRAFT_BRIDGE_V1", false),
  AI_GOVERNANCE_INTELLIGENCE_INTERACTION_V1: readBool("VITE_AI_GOVERNANCE_INTELLIGENCE_INTERACTION_V1", false),
  AI_PROVIDER_CONFIG_V2: readBool("VITE_AI_PROVIDER_CONFIG_V2", false),
  AI_DATA_POLICY_V1: readBool("VITE_AI_DATA_POLICY_V1", false),
  AI_DOCUMENT_INTELLIGENCE_V1: readBool("VITE_AI_DOCUMENT_INTELLIGENCE_V1", false),
  AI_DOCUMENT_RAG_V1: readBool("VITE_AI_DOCUMENT_RAG_V1", false),
  AI_DOCUMENT_RAG_QUALITY_V1: readBool("VITE_AI_DOCUMENT_RAG_QUALITY_V1", false),
  AI_LOCAL_MODELS_V1: readBool("VITE_AI_LOCAL_MODELS_V1", false),
  STANDARD_ACCESS_POLICY_V1: readBool("VITE_STANDARD_ACCESS_POLICY_V1", true),
  STANDARD_SCOPE_VISIBILITY_V1: readBool("VITE_STANDARD_SCOPE_VISIBILITY_V1", false),
  STANDARD_WRITE_GUARDRAILS_V1: readBool("VITE_STANDARD_WRITE_GUARDRAILS_V1", false),
  COMPLIANCE_TOPOLOGY_V1: readBool("VITE_COMPLIANCE_TOPOLOGY_V1", false),
  COMPLIANCE_TOPOLOGY_READINESS_V1: readBool("VITE_COMPLIANCE_TOPOLOGY_READINESS_V1", false),
  COMPLIANCE_WORKFLOW_V1: readBool("VITE_COMPLIANCE_WORKFLOW_V1", false),
  COMPLIANCE_REUSE_V1: readBool("VITE_COMPLIANCE_REUSE_V1", false),
  CONTROL_ASSURANCE_V1: readBool("VITE_CONTROL_ASSURANCE_V1", false),
  COMPLIANCE_RUNTIME_V1: readBool("VITE_COMPLIANCE_RUNTIME_V1", false),
  EXECUTIVE_GOVERNANCE_V1: readBool("VITE_EXECUTIVE_GOVERNANCE_V1", false),
  EXECUTIVE_POSTURE_WIDGETS_V1: readBool("VITE_EXECUTIVE_POSTURE_WIDGETS_V1", false),
  ENTERPRISE_OPERATIONAL_UX_V1: readBool("VITE_ENTERPRISE_OPERATIONAL_UX_V1", false),
  CANONICAL_CONTROL_LIBRARY_V1: readBool("VITE_CANONICAL_CONTROL_LIBRARY_V1", false),
  COMPLIANCE_EXECUTION_ORCHESTRATION_V1: readBool("VITE_COMPLIANCE_EXECUTION_ORCHESTRATION_V1", false),
  COMPLIANCE_READINESS_SYNC_V1: readBool("VITE_COMPLIANCE_READINESS_SYNC_V1", false),
  COMPLIANCE_SCOPE_AUTHORITY_V1: readBool("VITE_COMPLIANCE_SCOPE_AUTHORITY_V1", false),
  COMPLIANCE_EVIDENCE_BINDING_V1: readBool("VITE_COMPLIANCE_EVIDENCE_BINDING_V1", true),
  DOCUMENT_LIFECYCLE_V1: readBool("VITE_DOCUMENT_LIFECYCLE_V1", false),
  EVIDENCE_ARTIFACT_CATEGORIES_V1: readBool("VITE_EVIDENCE_ARTIFACT_CATEGORIES_V1", false),
  CONTROL_CENTRIC_WORKFLOW_UX_V2: readBool("VITE_CONTROL_CENTRIC_WORKFLOW_UX_V2", false),
  STANDARD_CONTROL_CENTRIC_UX_V1: readBool("VITE_STANDARD_CONTROL_CENTRIC_UX_V1", false),
  SOC2_AUTHORITATIVE_CORPUS_V1: readBool("VITE_SOC2_AUTHORITATIVE_CORPUS_V1", false),
  ENTERPRISE_OPERATIONAL_SEMANTIC_CORPUS_V1: readBool("VITE_ENTERPRISE_OPERATIONAL_SEMANTIC_CORPUS_V1", false),
  ENTERPRISE_AUTHORITATIVE_CORPUS_FREEZE_V1: readBool("VITE_ENTERPRISE_AUTHORITATIVE_CORPUS_FREEZE_V1", false),
  UNIFIED_REMEDIATION_AUTHORITY_V1: readBool("VITE_UNIFIED_REMEDIATION_AUTHORITY_V1", true),
  CONTINUOUS_COMPLIANCE_OPERATIONS_V1: readBool("VITE_CONTINUOUS_COMPLIANCE_OPERATIONS_V1", true),
};

